import { getAnalytics, logEvent, setUserProperties, setUserId } from "firebase/analytics";
import { mapGetters } from "vuex";
import { getApp } from "firebase/app";

const googleAnalytics = {
  data() {
    return {
      googleAnalytics: null,
      profileId: null,
    };
  },
  computed: {
    ...mapGetters(["profileid"]),
  },
  created() {
    try {
      const app = getApp(); // get default Firebase app
      this.googleAnalytics = getAnalytics(app);
    } catch (err) {
      console.warn("Firebase Analytics not initialized:", err);
    }
  },
  mounted() {
    this.profileId = this.profileid;
  },
  methods: {
    actAttachedUTMData(data) {
      let utm = {};
      try {
        const stored = JSON.parse(localStorage.getItem("utm_details_global") || '{}');
        for (const key of ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content']) {
          if (typeof stored?.[key] === 'string') utm[key] = stored[key];
        }
      } catch (_) { /* Invalid campaign storage must not drop playback events. */ }
      return { ...utm, ...data };
    },

    // --------------------- Generic GA logger ---------------------
    gaLogEvent(eventName, data) {
      if (!this.googleAnalytics) return false;
      let analyticsData = this.actAttachedUTMData({ ...data });
      const currentProfileId = analyticsData.profile_id || this.profileId || this.profileid || (this.$store && this.$store.getters ? this.$store.getters.profileid : null);
      if (currentProfileId) analyticsData.profile_id = String(currentProfileId);
      Object.keys(analyticsData).forEach(key => {
        const value = analyticsData[key];
        if (value == null || (typeof value === 'number' && !Number.isFinite(value))) delete analyticsData[key];
      });
      try {
        logEvent(this.googleAnalytics, eventName, analyticsData);
        return true; // Queued by the SDK; this is not a server acknowledgement.
      } catch (error) {
        console.warn(`Analytics event ${eventName} failed`, error);
        return false;
      }
    },

    // --------------------- Specific Events ---------------------
    loginEvent(data) {
      this.gaLogEvent("login", data);
    },
    logoutEvent(data) {
      this.gaLogEvent("logout", data);
    },
    SignupEvent(data) {
      this.gaLogEvent("sign_up", data);
    },
    watchedEvent(data) {
      return this.gaLogEvent("watched", data);
    },
    sharedEvent(data) {
      this.gaLogEvent("shared", data);
    },
    subscriptionStarted(data) {
      this.gaLogEvent("payment_started", data);
    },
    subscriptionDone(data) {
      this.gaLogEvent("charged", data);
    },
    subscriptionFailed(data) {
      this.gaLogEvent("payment_failed", data);
    },
    subscriptionCancelled(data) {
      this.gaLogEvent("subscription_cancelled", data);
    },
    searchEvent(data) {
      this.gaLogEvent("searched", data);
    },
    pageViewEvent(data) {
      this.gaLogEvent("page_view", data);
    },
    createProfileEvent(data) {
      this.gaLogEvent("create_profile", data);
    },
    userActionEvent(data) {
      this.gaLogEvent("action", data);
    },
    switchProfileEvent(data) {
      this.gaLogEvent("switch_profile", data);
    },
    deleteProfileEvent(data) {
      this.gaLogEvent("delete_profile", data);
    },
    ratedEvent(data) {
      this.gaLogEvent("rated", data);
    },
    referralEvent(data) {
      this.gaLogEvent("referral", data);
    },

    // --------------------- Telco Events ---------------------
    telco_error_event(data) {
      this.gaLogEvent("telco_landing_error", data);
    },
    telco_landing_event(data) {
      this.gaLogEvent("telco_landing_page", data);
    },
    telco_trial_initiated(data) {
      this.gaLogEvent("telco_trial_initiated", data);
    },
    telco_data_log(data) {
      this.gaLogEvent("telco_data_log", data);
    },
    telco_trial_success(data) {
      this.gaLogEvent("telco_trial_success", data);
    },
    telco_trial_failed(data) {
      this.gaLogEvent("telco_trial_failed", data);
    },
    telco_trial_cancelled(data) {
      this.gaLogEvent("telco_trial_cancelled", data);
    },
    telco_subscribe_now(data) {
      this.gaLogEvent("subscribe_now_intent", data);
    },
    telco_landing_page_tracker(data) {
      this.gaLogEvent("telco_landing_page_tracker", data);
    },
    telco_page_submission_tracker(data) {
      this.gaLogEvent("telco_page_submission_tracker", data);
    },

    contentWatched(data) {
      this.gaLogEvent("watched", data);
    },

    // --------------------- User Properties ---------------------
    setUserPropertiesFirebase(data) {
      if (!this.googleAnalytics) return;
      setUserProperties(this.googleAnalytics, data);
    },
    setAnalyticsUser(subscriberId) {
      if (!this.googleAnalytics || !subscriberId) return;
      setUserId(this.googleAnalytics, subscriberId);
      setUserProperties(this.googleAnalytics, { subscriber_id: subscriberId });
    },
  },
  watch: {
    profileid(newVal) {
      this.profileId = newVal;
    },
  },
};

export default googleAnalytics;
